import React, { Component } from "react";
import { Menu, Button, Dropdown } from "antd";

import WeaNewScroll from "../wea-new-scroll";
import WeaDropdown from "../wea-dropdown";
import WeaLocaleProvider from "../wea-locale-provider";
const getLabel = WeaLocaleProvider.getLabel;

const { ButtonSelect } = WeaDropdown;

class ActionButton extends React.PureComponent {
  onBtnClick = e => {
    const { buttonType, onClick } = this.props;
    if (typeof onClick === "function") onClick(buttonType);
  };
  render() {
    const { children, isDropBtn, btnDropProps, ...nextProps } = this.props;
    if (isDropBtn) {
      return (
        <Dropdown trigger={["click"]} {...btnDropProps}>
          <Button {...nextProps} onClick={this.onBtnClick}>
            {children}
          </Button>
        </Dropdown>
      );
    }
    return (
      <Button {...nextProps} onClick={this.onBtnClick}>
        {children}
      </Button>
    );
  }
}
export default class ActionButtons extends Component {
  static displayName = "ActionButtons";
  onMenuClick = e => {
    const { moveDropDatas } = this.props;
    const { onMenuClick } = moveDropDatas;
    typeof onMenuClick === "function" && onMenuClick(e.key, e);
  };
  onClick = e => {
    const { moveDropDatas } = this.props;
    const { addBtn } = moveDropDatas;
    if (Array.isArray(addBtn)) {
      addBtn.forEach(item => {
        typeof item.onClick === "function" &&
          item.key === e.key &&
          item.onClick(e.key, e);
      });
    } else {
      typeof addBtn.onClick === "function" && addBtn.onClick(e);
    }
  };
  getMoveDropPropsDatas() {
    const { moveDropDatas, prefixCls } = this.props;
    const { datas, addBtn } = moveDropDatas;
    if (Array.isArray(datas) && datas.length > 0) {
      return {
        move: {
          overlay: (
            <div
              className={`${prefixCls}-dropmenu-warp`}
              style={{
                paddingBottom: addBtn ? 32 : 0,
                maxHeight: Array.isArray(addBtn)
                  ? 194 + addBtn.length * 42
                  : 230
              }}
            >
              <WeaNewScroll height={(datas.length > 6 ? 6 : datas) * 32}>
                <Menu
                  prefixCls={`${prefixCls}-dropmenu ant-dropdown-menu`}
                  onClick={this.onMenuClick}
                >
                  {datas.map(d => (
                    <Menu.Item key={d.key} disabled={d.disabled}>
                      {d.show}
                    </Menu.Item>
                  ))}
                </Menu>
              </WeaNewScroll>
              <Menu
                prefixCls={`${prefixCls}-dropmenu ant-dropdown-menu`}
                onClick={this.onClick}
              >
                {addBtn ? (
                  Array.isArray(addBtn) ? (
                    addBtn.map(item => (
                      <Menu.Item
                        className={`${prefixCls}-dropmenu-addbtn`}
                        {...item}
                        key={item.key}
                        disabled={item.disabled}
                      >
                        {item.show}
                      </Menu.Item>
                    ))
                  ) : (
                    <div
                      className={`${prefixCls}-dropmenu-addbtn-single`}
                      {...addBtn}
                    >
                      {addBtn.show}
                    </div>
                  )
                ) : null}
              </Menu>
            </div>
          )
        }
      };
    }
    return {};
  }
  onBtnClick = key => {
    const { onBtnClick } = this.props;
    if (key && typeof onBtnClick === "function") {
      onBtnClick(key);
    }
  };
  onMenuClickAdd = e => {
    const { addDropDatas } = this.props;
    const { onMenuClick } = addDropDatas;
    typeof onMenuClick === "function" && onMenuClick(e.key, e);
  };
  getAddBtn() {
    const { showAdd, viewAttr, addButtonType, addDropDatas } = this.props;
    if (!showAdd) return null;
    const disabled = viewAttr === 1;
    const props = {
      type: "primary",
      disabled,
      size: "small",
      title: getLabel("611", "添加")
    };
    const { datas } = addDropDatas;
    if (addButtonType === "drop" && Array.isArray(datas) && datas.length > 0) {
      return (
        <Dropdown
          overlay={
            <Menu onClick={this.onMenuClickAdd}>
              {datas.map(d => (
                <Menu.Item key={d.key} disabled={d.disabled}>
                  {d.show}
                </Menu.Item>
              ))}
            </Menu>
          }
        >
          <Button {...props}>
            <i className="icon-coms-Add-to-hot" />
          </Button>
        </Dropdown>
      );
    }
    return (
      <ActionButton {...props} buttonType="add" onClick={this.onBtnClick}>
        <i className="icon-coms-Add-to-hot" />
      </ActionButton>
    );
  }

  getBtnsArray() {
    const { viewAttr, showDelete, showCopy, showMove, customBtns } = this.props;
    const readOnly = viewAttr === 1;
    let btns = [];
    if (!readOnly) {
      showDelete &&
        btns.push({
          key: "delete",
          text: getLabel("91", "删除"),
          show: <i className="icon-coms-form-delete-hot" />
        });
      showCopy &&
        btns.push({
          key: "copy",
          text: getLabel("77", "复制"),
          show: <i className="icon-coms-copy-hot" />
        });
      showMove &&
        btns.push({
          key: "move",
          text: getLabel("81296", "移动到组"),
          show: <i className="icon-coms-move2" />,
          isDropBtn: true
        });
      if (customBtns) {
        btns = [...btns, ...customBtns];
      }
    }
    return btns;
  }
  onCollapse = () => {
    const { collapsed, onCollapse } = this.props;
    if (typeof onCollapse === "function") onCollapse(!collapsed);
  };
  getCollapseBtn() {
    const { showCollapse, collapsed, onCollapse } = this.props;
    return showCollapse ? (
      <i
        style={{
          marginLeft: 10,
          color: "#b2b2b2",
          cursor: "pointer",
          lineHeight: "20px"
        }}
        className={`icon-coms-${collapsed ? "down" : "up"}`}
        onClick={this.onCollapse}
      />
    ) : null;
  }

  getBtnsInline() {
    const { viewAttr, selectedRowKeys } = this.props;
    const readOnly = viewAttr === 1;
    const btns = this.getBtnsArray();
    const btnDropPropsDatas = this.getMoveDropPropsDatas();
    return btns.map(btn => (
      <ActionButton
        type="primary"
        disabled={readOnly || !`${selectedRowKeys}`}
        title={btn.text}
        size="small"
        buttonType={btn.key}
        isDropBtn={btn.isDropBtn}
        btnDropProps={btnDropPropsDatas[btn.key] || { overlay: <span /> }}
        onClick={this.onBtnClick}
      >
        {btn.show}
      </ActionButton>
    ));
  }

  getBtnsSelect() {
    const btns = this.getBtnsArray();
    if (btns.length === 0) return null;
    const {
      selectedBtnKey,
      viewAttr,
      selectedRowKeys,
      onBtnsSelect
    } = this.props;
    const readOnly = viewAttr === 1;
    const selectedKey = selectedBtnKey || btns[0].key;
    const selected = btns.filter(b => b.key === selectedKey);
    const btn = selected[0];
    const btnDropPropsDatas = this.getMoveDropPropsDatas();
    if (btns.length === 1) {
      return (
        <ActionButton
          type="primary"
          disabled={readOnly || !`${selectedRowKeys}`}
          title={btn.text}
          size="small"
          buttonType={btn.key}
          onClick={this.onBtnClick}
        >
          {btn.show}
        </ActionButton>
      );
    }
    return (
      <ButtonSelect
        type="small"
        selectedKey={selectedKey}
        btnProps={{
          title: btn.text || "",
          disabled: readOnly || !`${selectedRowKeys}`,
          size: "small"
        }}
        datas={btns}
        btnDropPropsDatas={btnDropPropsDatas}
        btnOnClick={this.onBtnClick}
        menuOnClick={key => onBtnsSelect(key)}
      />
    );
  }

  render() {
    const { prefixCls, buttonsType, columns } = this.props;
    if (columns.length === 0) return null;
    return (
      <span className={`${prefixCls}-btns`}>
        {this.getAddBtn()}
        {buttonsType === "inline" ? this.getBtnsInline() : this.getBtnsSelect()}
        {this.getCollapseBtn()}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./ecology9/wea-table-editable/ActionButtons.js